import { render, staticRenderFns } from "./productCheck.vue?vue&type=template&id=b016397c"
import script from "./productCheck.vue?vue&type=script&lang=js"
export * from "./productCheck.vue?vue&type=script&lang=js"
import style0 from "./productCheck.vue?vue&type=style&index=0&id=b016397c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports